import styled from 'styled-components';

export const Blankspace = styled.div`
  height: 100px;
`;

export const IconShadow = styled.div`
  width: 200px;
  height: 100px;
  box-shadow: 0px -50px 100px 60px rgba(0, 0, 0, 0.15);
  border-radius: 50% 50% 0 0 / 100% 100% 0 0;
  position: absolute;
  margin-left: 10px;
  margin-bottom: 10px;
  bottom: 0;
  left: 0;
  z-index: -5;
`;

export const IconContainer = styled.div`
  position: relative;
  width: 15%;
  margin: 0 auto;
`;

export const IconWrapper = styled.div`
  position: relative;
  bottom: -7px;
  z-index: 1;
`;

export const ErrorMainText = styled.p`
  font-size: 24px;
  font-family: 'Graphik', helvetica;
  font-weight: bold;
  text-align: center;
  background: #f2f2f2;
  padding-top: 24px;
  margin: 0;
`;

export const ErrorSubText = styled.p`
  font-size: 100%;
  font-family: 'Graphik', helvetica;
  text-align: center;
`;

export const ErrorWrapper = styled.div`
  background: #f2f2f2;
  position: absolute;
  width: 100%;
  height: 110%;
  z-index: -6;
`;

export const ErrorTextBox = styled.div`
  width: 533px;
  height: 166px;
  margin: 0 auto;
  margin-top: 10px;
  padding-top: 10px;
  overflow-y: scroll;
  background: #ffffff;
  border-style: solid;
  border-width: 1px;
  border-color: #bbbbbb;
  border-radius: 3px;
  white-space: pre-line;
  ::-webkit-scrollbar {
    width: 15px;
  }
  ::-webkit-scrollbar-track {
    background: #f2f2f2;
  }
  ::-webkit-scrollbar-thumb {
    background: #bcbec0;
    border-radius: 100px;
    border: 3px solid #f2f2f2;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #bcbec0;
  }
`;

export const ErrorTextHeader = styled.div`
  font-family: 'Graphik', helvetica;
  font-weight: bold;
  font-size: 100%;
  text-align: left;
  padding-left: 10px;
`;

export const ErrorText = styled.div`
  font-family: 'Graphik', helvetica;
  font-size: 14px;
  text-align: left;
  padding: 10px;
`;
